import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/enviroments';
import { InfoClient } from '../interface/company-client.interface';

@Injectable({
  providedIn: 'root',
})
export class ContactInfoService {
  constructor(private http: HttpClient) {}

  getInfoClientTable(companyId: number) {
    const endpoint = `${environment.apiUrl}/ContactCompanies/InfoContactCompanies/${companyId}`;
    return this.http.get<InfoClient[]>(endpoint);
  }
  CreateInfoClient(request: InfoClient, companyId: number) {
    console.log(request, companyId);

    const endpoint = `${environment.apiUrl}/ContactCompanies/CreateContactForm/${companyId}`;
    return this.http.post<string>(endpoint, request);
  }
  UpdateInfoClient(request: InfoClient, contactRut: number) {
    const endpoint = `${environment.apiUrl}/ContactCompanies/UpdateContactForm/${contactRut}`;
    return this.http.put<string>(endpoint, request);
  }
  DeleteInfoClient(contactRut: number) {
    const endpoint = `${environment.apiUrl}/ContactCompanies/DeleteContact/${contactRut}`;
    return this.http.delete<string>(endpoint);
  }
  getContact(rut:string) {
    const endpoint = `${environment.apiUrl}/ContactCompanies/${rut}/GetContactCompanies`;
    console.log(endpoint);
    return this.http.get<InfoClient[]>(endpoint)
  }
}
